import JoinNowForm from "../JoinNowForm";
import Bounce from "react-reveal/Bounce";
import {
  JoinContainer,
  JoinWrapper,
  JoinRow,
  Column1,
  Column2,
  TextWrapper,
  Heading,
  Subtitle,
  CTASection,
  ImgWrap,
  Img,
} from "./JoinElements";

const JoinSection = ({ id, headline, imgStart, img, alt, buttonLabel }) => {
  return (
    <>
      <JoinContainer id={id}>
        <JoinWrapper>
          <JoinRow imgStart={imgStart}>
            <Bounce right>
              <Column1>
                <TextWrapper>
                  <Heading>{headline}</Heading>
                  <Subtitle>
                    Join our wait list and be among the first to know when
                    Paythumb launches.
                  </Subtitle>
                </TextWrapper>

                <CTASection>
                  <JoinNowForm />
                </CTASection>
              </Column1>
            </Bounce>
            <Column2>
              <ImgWrap>
                <Img src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </JoinRow>
        </JoinWrapper>
      </JoinContainer>
    </>
  );
};

export default JoinSection;
